/**
 * Control Center Tour
 *
 * Guides users through key settings pages: the hub, pipeline config,
 * integrations, and Astor agent configuration.
 */

import type { TourConfig } from './tour-config.types';

export const controlCenterTour: TourConfig = {
  id: 'control-center-overview',
  title: 'tours.controlCenter.title',
  portal: 'business',
  steps: [
    {
      target: '[data-astor-id="control-center-hub"]',
      content: 'tours.controlCenter.steps.hub',
      placement: 'bottom',
      route: '/control-center',
    },
    {
      target: '[data-astor-id="pipeline-config"]',
      content: 'tours.controlCenter.steps.pipeline',
      placement: 'bottom',
      route: '/control-center/pipeline',
    },
    {
      target: '[data-astor-id="integrations-config"]',
      content: 'tours.controlCenter.steps.integrations',
      placement: 'bottom',
      route: '/control-center/integrations',
    },
    {
      target: '[data-astor-id="settings-astor-agents"]',
      content: 'tours.controlCenter.steps.astorAgents',
      placement: 'bottom',
      route: '/control-center/astor-agents',
    },
  ],
};
